import { createContext } from 'react';

export type SinglePaymentCtx = {
  showSinglePaymentErrorAlert: boolean;
  singlePaymentError: string;
  showSinglePaymentConfirmAlert: boolean;
};

const SinglePaymentDialogueContext = createContext<SinglePaymentCtx>({
  showSinglePaymentErrorAlert: false,
  singlePaymentError: '',
  showSinglePaymentConfirmAlert: false,
});

export default SinglePaymentDialogueContext;